import { BestPriceGuaranteeModalContent } from "@apac/components/ui";
import { type IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
  Icon,
} from "@tenant/ui";
import { ApacUiComponent } from "../../context";
import { useApacUiStyles } from "../../hooks";
import defaultStyles from "./styles.module.scss";

export const BestPriceGuaranteeLink = ({
  iconName,
}: {
  iconName?: IconNameEnum;
}) => {
  const styles = useApacUiStyles(
    ApacUiComponent.BestPriceGuaranteeLink,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(
    styles,
    ApacUiComponent.BestPriceGuaranteeLink
  );

  const { t } = useI18nContext();
  return (
    <Dialog>
      <DialogTrigger
        className={cn("trigger")}
        aria-label={t("apac.bestPriceGuarantee.title")}
      >
        {iconName != null && <Icon iconName={iconName} />}
        <span className={cn("trigger-link")}>
          {t("apac.bestPriceGuarantee.title")}
        </span>
      </DialogTrigger>
      <DialogContent
        className={block}
        title={t("apac.bestPriceGuarantee.title")}
      >
        <BestPriceGuaranteeModalContent />
        <DialogClose className={cn("close-button")}>
          {t("close.button")}
        </DialogClose>
      </DialogContent>
    </Dialog>
  );
};
